import React, { useState, useEffect } from 'react';

interface BrandImageProps {
  src: string;
  alt: string;
  className?: string;
  onError?: (brandName: string) => void;
  fallbackType?: 'hide' | 'text';
  onClick?: () => void;
}

const BrandImage: React.FC<BrandImageProps> = ({
  src,
  alt,
  className = '',
  onError,
  fallbackType = 'hide',
  onClick
}) => {
  const [hasError, setHasError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 2;

  useEffect(() => {
    setHasError(false);
    setRetryCount(0);
  }, [src]);

  const handleImageError = () => {
    if (retryCount < MAX_RETRIES) {
      setRetryCount(prev => prev + 1);
    } else {
      setHasError(true);
      if (onError) {
        onError(alt);
      }
    }
  };

  // Si falló la carga y el fallback es ocultar
  if (hasError && fallbackType === 'hide') {
    return null;
  }

  // Si falló la carga y el fallback es mostrar texto estilizado
  if (hasError && fallbackType === 'text') {
    return (
      <div 
        className={`flex items-center justify-center rounded-lg bg-white/10 border border-white/20 px-2 py-1 shadow-sm w-full h-full ${className}`}
        onClick={onClick}
      >
        <span className="text-amber-200 font-bold text-[11px] md:text-xs text-center uppercase tracking-wider line-clamp-1">
          {alt}
        </span>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex items-center justify-center">
      <img
        src={`${src}${retryCount > 0 ? `?retry=${retryCount}` : ''}`}
        alt={alt}
        className={`${className} object-contain mx-auto`}
        onError={handleImageError}
        onClick={onClick}
        loading="eager"
        decoding="async"
      />
    </div>
  );
};

export default BrandImage;
